import PhotoSwipeLightbox from "photoswipe/src/js/lightbox/lightbox.js";

const lightbox = new PhotoSwipeLightbox({
  gallery: ".gallery",
  children: "a",
  pswpModule: () => import("photoswipe/src/js/photoswipe.js"),
});

lightbox.init();
